"use client";

import { useMemo } from "react";
import type { ReactElement } from "react";

import CardCarousel from "@/src/component/partial/CardCarousel/CardCarousel";

import styles from "./MessageCarousel.module.scss";

interface Message {
  id: string;
  title: string;
  message: string;
}

interface MessageCarouselProps {
  messages: Message[];
  autoPlayDelay?: number;
  className?: string;
  id: string;
}

function MessageCarousel({ messages, autoPlayDelay = 3000, className, id }: MessageCarouselProps) {
  const carouselChildren: ReactElement[] = useMemo(() => {
    return (messages ?? []).map((message) => (
      <div
        key={message.id}
        className={styles.messageCard}
      >
        <h3 className={styles.messageTitle}>{message.title}</h3>
        <p className={styles.messageText}>{message.message}</p>
      </div>
    ));
  }, [messages]);

  const breakpoints = useMemo(
    () => ({
      1025: {
        slidesPerView: 1,
      },
      200: {
        slidesPerView: 1,
      },
    }),
    []
  );

  const autoplayConfig = useMemo(() => {
    return {
      delay: autoPlayDelay,
      disableOnInteraction: false,
    };
  }, [autoPlayDelay]);

  if (!messages || messages.length === 0) {
    return null;
  }

  return (
    <div className={`${styles.advancedMessageCarousel} ${className || ""}`}>
      <CardCarousel
        id={id}
        slidesPerView={1}
        spaceBetween={0}
        loop={true}
        centerSlides={true}
        breakpoints={breakpoints}
        autoplay={autoplayConfig}
        showButtons={false}
        classes={{
          container: styles.carouselContainer,
          swiper: styles.carouselSwiper,
        }}
      >
        {carouselChildren}
      </CardCarousel>
    </div>
  );
}

export default MessageCarousel;
